// extracted by mini-css-extract-plugin
export default {"formHeading":"mL-z","form":"nL-z","submitBtn":"oL-z","disabled":"pL-z","input":"qL-z","error":"rL-z","submitMsg":"sL-z","signIn":"tL-z"};